<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <!-- <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button> -->
            <div class="protocol-header">
                <h1>智步云上模型网授权协议</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <h2>甲方（被授权方）：个人/个体工商户/企业/社会组织/团体
                    </h2>
                    <h2>乙方（授权方）：个人/个体工商户/企业/社会组织/团体
                    </h2>
                    <p>平台方智步云上模型网上交易平台，是一家以3D数字模型交易为主并同时综合线上学习、作品展示交流、作品版权登记等功能的智步云上在线平台，为广大从事智步云上艺术的企业、从业者、爱好者等提供交易、学习、交流、就业、知识产权、IP授权、衍生品开发等一站式服务。
                    </p>
                    <p>为充分发挥甲乙双方优势 ，互利共赢，根据《中华人民共和国著作权法》、《中华人民共和国民法典》等相关法律、法规之规定，针对乙方作品的许可使用事宜，甲乙双方遵循平等、自愿、公平原则，达成如下协议并共同遵守</p>
                </div>
                <div class="protocol-section">
                    <h2>一、定义</h2>
                    <p>本协议中的有关词语含义如下：
                    </p>
                    <p>1.注册用户：指通过智步云上模型网上交易平台平台注册的或以第三方账号登录智步云上模型网上交易平台平台的，与智步云上模型网上交易平台有唯一且不可变更的一一指代关系的信息.
                    </p>
                    <p>2.作品：是经发布用户原创或依法取得有效授权的作品，包括但不限于美术作品、摄影作品、电影作品和以类似摄制电影的方法创作的图片、三维模型、视频等。
                    </p>
                    <p>3.授权：指作品著作权许可使用的授权 ，不涉及著作权权属的转移。</p>
                    <p>4.授权方：指上传作品至智步云上模型网上交易平台进行授权出售的实名认证用户。</p>
                    <p>5.使用：指对作品进行复制、修改、展览、发布或其他形式的使用。</p>
                    <p>6.购买方：是指通过智步云上模型网上交易平台向授权方支付费用，下载由授权方提供作品的智步云上模型网上交易平台注册用户。购买方除下载作品外还需要完成作品使用权授权操作 ，通过填写授权信息并获取授权书明确作品的被授权方 ，购买方既可以明确自身为被授权方 ，也可以指定其他民事主体作为被授权方。若购买方未获取授权书 ，视为授权未完成且未获得授权许可使用。</p>
                    <p>7.被授权方：指购买方根据《智步云上模型网上交易平台服务协议》、《智步云上模型网上交易平台模型授权协议》和智步云上模型网上交易平台授权规则在授权书中列明的民事主体 ，被授权方有权依据授权书指定的授权范围使用作品。</p>
                </div>
                <div class="protocol-section">
                    <h2>二、授权许可与限制</h2>
                    <p>1.乙方根据市场情况和用户需求，针对不同的需求方提供不同范围的授权许可，分为智步云上模型网上交易平台上公示的个人授权、企业授权和企业扩展授权。</p>
                    <p>2.本协议约定作品的授权范围为以下范围内的复制权、修改权、展览权、信息网络传播权，被授权方 对除著作权外的其它未明确标识享有的权利进行使用的．需另行获取授权方相关授权。</p>
                    <p>3.授权范围：
                    </p>
                    <p>以智步云上模型网上交易平台上公示的个人授权、企业授权和企业扩展授权为准。
                    </p>
                    <p>4.被授权方使用作品的禁止性规定</p>
                    <p>4.1 禁止通过转售、再次分销、共享等方式转让或实质性转授权任何作品。
                    </p>
                    <p>4.2 作品授权类型为个人授权的 ，严禁将作品用于企业行为 （包括企业商业使用和非商业使用）。
                    </p>
                    <p>4.3 禁止超出本授权书约定的授权范围使用作品。</p>
                    <p>4.4 使用作品不得侵犯第三方的肖像权、名誉权、隐私权等人身权益，也不得侵犯第三方的著作权、 商标权等其他知识产权</p>
                    <p>4.5 禁止利用作品发布涉嫌欺骗性广告或有不正当竞争的行为。</p>
                    <p>4.6 禁止将作品用于色情、违背社会公序良俗或不道德的目的。</p>
                    <p>4.7 禁止将作品用于任何违反法律法规的宣传或宣传品，或用于丑化诋毁或攻击任何个人或社会团体的场景。
                    </p>
                    <p>4.8 禁止将作品用于可能使作品中人物遭受诽谤、 冒犯、贬低、误解或其他不当评价的场景。
                    </p>
                    <p>4.9 作品中涉及的国旗国徽等党政图案仅作为作品整体效果示例展示 ，禁止用于任何商业用途。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>三、其他约定</h2>
                    <p>1.除另有明确约定外，乙方授予甲方非排他性的、非独家的、不可转让的、全球性的作品使用权利，使用期限为永久。
                    </p>
                    <p>2.甲方知悉并理解：本协议的授权为单一授权许可，仅授权甲方一位自然人或者一个企业下载和使用作品内容；对于公有领域素材 ，乙方向甲方收取的费用为素材使用费 ，并非素材许可费。</p>
                    <p>3.甲方同时已经阅读知悉 智步云上模型网上交易平台《智步云上模型网上交易平台服务协议》、《智步云上模型网上交易平台买家协议》及本授权协议的限制条款 ，并同意在遵守该文件和条款的前提下使用和复制作品。</p>
                </div>
                <div class="protocol-section">
                    <h2>四、声明与保证</h2>
                    <p>1.乙方声明和保证：
                    </p>
                    <p>1.1 乙方拥有本协议中作品的完整著作权，合法有效。</p>
                    <p>1.2 乙方授权的作品作品不会：（1）侵犯任何著作权、商标权或其他知识产权；（2）侵犯任何第三方的隐私权或其他权利；（3）违反任何中华人民共和国法律、法令、条例或法规。</p>
                    <p>1.3 乙方会尽商业上合理的努力来确保对内容进行描述的关键字和说明的准确性，包括：（1）关键字、标题或说明；（2）模型作品中的渲染、贴图、材质等。</p>
                    <p>1.4 除本协议声明与保证条款明确做出的保证之外，乙方未做出任何陈述或保证。若乙方违反本条款，则需退还甲方已支付的所有费用。授权的作品作品涉及对第三方的侵权纠纷时，乙方应独立承担全部侵权责任 ，并赔偿因此给甲方造成的相关损失。</p>
                    <p>2.甲方声明和保证：</p>
                    <p>2.1 甲方理解并同意乙方授权的作品属于不宜退、换货的特殊商品，甲方通过自行使用 智步云上模型网上交易平台账号下载本协议授权作品 ，乙方不再另行进行其他交付行为，甲方在购买作品授权前已经明确了解和知悉该作品的所有属性，除经乙方确认，作品确有质量问题外，一经出售概不退换，乙方有权拒绝甲方的退、换货申请，且不承担任何责任。</p>
                    <p>2.2 甲方妥善保管好其所有的 智步云上模型网上交易平台账号及密码，所有登录甲方账号、以甲方账号进行的行为，都视为甲方的行为，对甲方产生法律约束力。</p>
                    <p>2.3 除本协议声明与保证条款明确做出的保证之外，甲方未做出任何陈述或保证。若甲方违反本条款，未在本协议许可范围内使用乙方授权作品，甲方应独立承担全部侵权责任，并赔偿因此给乙方造成的相关损失。</p>
                    <p>3.平台方声明和保证：</p>
                    <p>3.1 智步云上模型网上交易平台应为交易双方提供良好的网络服务支持，并努力让双方的交易更便捷、高效、安全。</p>
                    <p>3.2 根据法律法规、规章制度、相关政策及智步云上模型网上交易平台的规定，监测买卖双方出售和使用作品的合法合规。</p>
                    <p>3.3 当甲方或者乙方因协议授权作品产生各种纠纷包括法律纠纷，导致权益受到损害，纠纷和由纠纷带来的相关损失由双方自行解决，智步云上模型网上交易平台作为网络服务平台，无需承担任何责任。智步云上模型网上交易平台应当配合提供与此相关的证据 ，并配合甲方或者乙方的维权。</p>
                </div>
                <div class="protocol-section">
                    <h2>五、违约责任</h2>
                    <p>除不可抗力因素外 ，甲乙双方在本协议执行过程中，任何一方违反本协议约定内容，另一方有权解除协议，并要求对方赔偿造成的实际损失及救济的合理支出费用。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>六、协议的效力</h2>
                    <p>1.本协议于甲方、乙方双方线上签订之日起生效，若无违反本协议情况，任何一方不得单方面撤销协议。除非本协议另有约定，协议期限为永久。
                    </p>
                    <p>2.本协议签订前 ，甲、乙双方就本协议所涉事项所达成的协议、合同、备忘录等文件均为本协议所取代，前述文件与本协议有任何不一致之处，以本协议为准。</p>
                    <p>3.本协议任何条款被认定为无效或不具备强制执行力的 ，不影响本协议其他条款的效力 ，其他条款仍具有协议约束力和法律效力。</p>
                </div>
                <div class="protocol-section">
                    <h2>七、争议解决及其他</h2>
                    <p>本协议适用中华人民共和国法律。因执行本协议所发生的或与本协议有关的一切争议，甲乙双方应通过友好平等协商解决 ，协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>八、保密条款</h2>
                    <p>1.协议各方保证：对因签署本协议所获悉属于对方的 ，且无法自公开渠道获得的文件资料及信息（包括但不限于作品信息、个人隐私、商业秘密、财务信息、技术信息等） ，以及本协议内容 ，予以保密。除法律、法规另有约定或各方另有约定外，未经对方书面同意，任何一方均不得以任何方式利用或向任何协议无关方泄露属于对方的保密信息的全部或部分内容。</p>
                    <p>2.以上保密条款并不因本协议的解除、终止、撤销而失效。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>九、协议的变更、解除和终止</h2>
                    <p>1.甲乙双方协商一致，可书面变更本协议。
                    </p>
                    <p>2.因不可抗力导致本协议目的不能实现的，任何一方有权解除本协议。不可抗力是指本协议双方不能合理控制、不可预见或即使预见亦无法避免的事件。上述事件包括但不限于政府行为、地震、台风、洪水、火灾或其它天灾、战争、任何一方破产、遭到破产或申请破产或任何其它类似事件。</p>
                    <p>3.协议未尽事宜，双方可另行签订补充协议。
                    </p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>